import OrganizationTable from './OrganizationTable';
import OrganizationCard from './OrganizationCard';
import { FC } from 'react';
import { Card } from 'src/shared/components/index';
import { OrganizationData } from '../models';
import { LIST_VIEW } from 'src/shared/constants/constants';

interface OrganizationViewProps {
  className?: string;
  handleEditIconClick: (row: any) => void;
  handleTenantNameClick(row: any): void;
  inputOrganizationData: OrganizationData[];
  inputSelectedTab: string;
  inputLoginUserRole: string;
}

const OrganizationView: FC<OrganizationViewProps> = ({
  handleEditIconClick,
  handleTenantNameClick,
  inputSelectedTab,
  inputLoginUserRole,
  inputOrganizationData
}) => {
  return (
    <>
      {inputSelectedTab === LIST_VIEW.CARD_VIEW && (
        <OrganizationCard
          inputOrganizationData={inputOrganizationData}
          handleEditIconClick={handleEditIconClick}
        />
      )}
      {inputSelectedTab === LIST_VIEW.TABLE_VIEW && (
        <Card className="mb-25">
          <OrganizationTable
            inputLoginUserRole={inputLoginUserRole}
            handleEditIconClick={handleEditIconClick}
            handleTenantNameClick={handleTenantNameClick}
            inputOrganizationData={inputOrganizationData}
          />
        </Card>
      )}
    </>
  );
};

export default OrganizationView;
